module.exports = __webpack_public_path__ + "static/sport/game-5.06daf49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ldp/game-5.png
// module id = Fvts
// module chunks = 0